import request from 'superagent'
import {getAddressFromCoordinates} from 'conf'

export default (query, cb) => 
  request
    .post(getAddressFromCoordinates())
    .send(query)
    .set('Content-Type', 'application/json; charset=utf-8')
    .type('json')
    .end((err, res) => err ? cb(err) : cb(null, res.body))




/** WEBPACK FOOTER **
 ** ./app/api/reverseGeocode.js
 **/